export default "__VITE_ASSET__771bffc2__"